// src/components/Blocks/DataFromRSS/Data.jsx
import React from 'react';
import { BlockDataForm } from '@plone/volto/components';
import Schema from './schema';
import { injectIntl } from 'react-intl';

const RSSDataForm = (props) => {
  const { data, block, onChangeBlock, blocksConfig, intl } = props; // Aggiunto intl
  const schema = Schema({ ...props }); // Passa tutti i props, incluso intl

  return (
    <>
      <BlockDataForm
        schema={schema}
        title="RSS Feed Block Settings"
        onChangeField={(id, value) => {
          onChangeBlock(block, {
            ...data,
            [id]: value,
          });
        }}
        onChangeBlock={onChangeBlock}
        formData={data}
        block={block}
        blocksConfig={blocksConfig}
      />
    </>
  );
};

export default injectIntl(RSSDataForm); // Inietta intl